<script>
import { mapGetters} from 'vuex'
import _ from 'lodash'

export default
{
    name: 'mv-image-browser',

    computed: mapGetters({
        list: 'attachmentsList',
        currentFilter: 'attachmentsFilter',
        loading: 'attachmentsLoading',
    }),

    methods:
    {
        doFilter: _.debounce(function(filter) {
            this.$store.dispatch('attachmentsFilter', filter.target.value)
        }, 500),

        selected(item)
        {
            this.$emit('selected', item)
        },

        toPage(num)
        {
            this.$store.dispatch('attachmentsPage', num)
        }
    },

}
</script>

<template>
<div class="image-browser container-fluid">
    <div class="input-group">
        <span class="input-group-addon">File</span>
        <input type="text" name="filter" class="form-control" :value="currentFilter" @input="doFilter">
    </div>
    <div class="row">
        <div class="loader" v-show="loading"><div></div></div>
        <div class="col-xs-6 col-sm-5 col-lg-4" v-for="item in list.data" :key="item.id">
            <div class="item" @click="selected(item)">
                <img :src="item.thumbnail_url" :alt="item.display_name" style="width: 100%;">
                <div>{{ item.display_name }}</div>
            </div>
        </div>
    </div>
    <div class="row" v-if="list && list.data">
        <div class="col-sm-12 text-center">
            <mv-pager :data="list" @page="toPage($event)"></mv-pager>
        </div>
    </div>
</div>
</template>

<style lang="scss">
.image-browser {
    margin-bottom: 2em;
    background-color: #eee;
    padding: .5em;
    border: 1px solid darkgrey;

    .item {
        cursor: pointer;
        background-color: grey;
        text-align: center;
        margin: .5em auto;
        padding: 1em 0 .5em 0;
        /* width: 230px; */
        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: 5px;
        transition: all .5s;
        user-select: none;

        img {
            width: 227px;
            max-width: 227px;
            height: 128px;
            max-height: 128px;
        }

        & > div {
            text-overflow: ellipsis;
            font-weight: bold;
        }

        &:hover {
            background-color: lightgrey;
        }

    }

    .loader {
        visibility: visible;
        opacity: 1;
        transition: all .5s;
        padding: 1em;
        div {
            display: block;
            width: 100px;
            height: 100px;
            border-radius: 80px;
            box-shadow: 0 6px 0 0 darkgrey;
            margin: 0 auto;
            animation: loading-anim 1s linear infinite;
        }
    }
}
@keyframes loading-anim { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }

</style>



// WEBPACK FOOTER //
// src/components/ImageBrowser.vue